export default "__VITE_ASSET__ba54aa3b__"